// JW Player's captions list always starts with "Off" at index 0, so a real
// track is only ever at index >= 1. findIndex returns -1 on a miss, which is
// truthy — never branch on the raw index.
// Consumed by player.js via pack app/javascript/packs/web_v1_movies_watch.js.
export function captionsIndexForLabel(captionsList, label) {
    if (!Array.isArray(captionsList)) {
        return 0;
    }

    const index = captionsList.findIndex(function(captions) {
        return captions.label === label;
    });

    return index > 0 ? index : 0;
}

// Subtitles-modal → JW Player bridge used by Play. Never pass a negative index.
export function applySubtitleLabel(player, label) {
    if (!player || typeof player.setCurrentCaptions !== 'function') {
        return 0;
    }

    const list = typeof player.getCaptionsList === 'function' ? player.getCaptionsList() : [];
    const index = captionsIndexForLabel(list, label);
    player.setCurrentCaptions(index);
    return index;
}
